<template>
  <PresetsEditingBaseView
    :onPrimaryButtonPressed="onPrimaryButtonPressed"
    title="Edit preset"
    primaryButtonText="Save"
    icon="mdi-pencil"
    :profileData="profileData"
    subtitle="Edit the fields below to update the preset"
    :requestLoading="updateLoading"
    :buttonDisabled="false"
    :onNameChanged="onNameChanged"
    :onLowerHeatingValueChanged="onLowerHeatingValueChanged"
    :onMeanDraftChanged="onMeanDraftChanged"
    :onTrimChanged="onTrimChanged"
    :onTrueWindChanged="onTrueWindChanged"
    :onWindDirectionChanged="onWindDirectionChanged"
    :onSpeedThroughWaterChanged="onSpeedThroughWaterChanged"
    :onFoulingChanged="onFoulingChanged"
    :onUseLatestFoulingChanged="onUseLatestFoulingChanged"
    :onDateChanged="onDateChanged"
    :onDialogActivated="setProfileData"
    :showSuccessSnackBar="showSuccessSnackBar"
    :showErrorSnackBar="showErrorSnackBar"
    :onSnackBarClosed="onSnackBarClosed"
  >
  </PresetsEditingBaseView>
</template>




<script>
import PresetsEditingBaseView from "./BaseView.vue";
import { mapState, mapActions } from "vuex";
export default {
  name: "PresetsEditingEditView",
  components: {
    PresetsEditingBaseView,
  },
  data() {
    return {
      showSuccessSnackBar: false,
      showErrorSnackBar: false,
    };
  },
  computed: {
    ...mapState("kDiagram/profiles", ["selectedProfile"]),
    ...mapState("kDiagram/profiles/editProfile", [
      "profileData",
      "updateLoading",
      "updateError",
      "profileUpdateFailed",
      "profileUpdateSuccess",
    ]),
  },
  methods: {
    ...mapActions("kDiagram/profiles/editProfile", ["updateProfile"]),
   async onPrimaryButtonPressed() {
  await this.updateProfile({
    vesselName: this.$route.params.vessel,
    profileData: this.profileData,
  });

    },
    setProfileData() {
      this.$store.commit(
        "kDiagram/profiles/editProfile/SET_PROFILE_DATA",
        Object.assign({}, this.selectedProfile)
      );
    },
    onUseLatestFoulingChanged(value) {
    this._onAttributeChanged("useLatestFouling", value);
  },
    onNameChanged(value) {
      this._onAttributeChanged("profileName", value);
    },
    onLowerHeatingValueChanged(value) {
      this._onAttributeChanged("lhv", value);
    },
    onMeanDraftChanged(value) {
      this._onAttributeChanged("draft", value);
    },
    onTrimChanged(value) {
      this._onAttributeChanged("trim", value);
    },
    onTrueWindChanged(value) {
      this._onAttributeChanged("trueWind", value);
    },
    onWindDirectionChanged(value) {
      this._onAttributeChanged("windDirection", value);
    },
    onSpeedThroughWaterChanged(value) {
      this._onAttributeChanged("valuesList", value);
    },
    onFoulingChanged(value) {
      this._onAttributeChanged("fouling", value);
    },
    onDateChanged(dateRange) {
      this._onAttributeChanged("minDate", dateRange.minDate);
      this._onAttributeChanged("maxDate", dateRange.maxDate);
    },
    _onAttributeChanged(attribute, value) {
      this.$store.commit(
        "kDiagram/profiles/editProfile/SET_PROFILE_DATA_ATTRIBUTE",
        {
          attribute: attribute,
          value: value,
        }
      );
    },
    onSnackBarClosed() {
      this.$store.commit("kDiagram/profiles/editProfile/RESTORE_REQUEST_STATE");
    },
  },
  watch: {
    profileUpdateSuccess: {
      handler(newVal) {
        if (newVal != null) {
          this.showSuccessSnackBar = newVal;
        }
      },
    },
    profileUpdateFailed: {
      handler(newVal) {
        if (newVal != null) {
          this.showErrorSnackBar = newVal;
        }
      },
    },
  },
};
</script>
